module.exports = (Promise.resolve(__parcel__require__("./" + "module.1a76ec57.332b7ed0.js"))).then(() => parcelRequire('94hho'));